import { ConvexReactClient } from "convex/react";

// Single Convex client per browser session. Reads VITE_CONVEX_URL from
// the build environment. Throws synchronously at module load if missing
// — better to fail loudly than to crash on every useQuery later.
const url = import.meta.env.VITE_CONVEX_URL as string | undefined;
if (!url) {
  throw new Error("VITE_CONVEX_URL is not set. Add it to .env.local or your Vite environment.");
}

export const convex = new ConvexReactClient(url);
